
export function connMTUpdater(conf) {
    const self = this;
    this.conf = conf || {};

    var doneOnce = false;
    var animateId = 0;
    var $connMT = $(conf.selector || '.connMT');

    this.updateTitle = function (counterTitle) {
        $connMT.filter('.cmtstats').add($connMT.find('.cmtstats')).attr('title', counterTitle);
    };

    this.update = function (html, counter, counterTitle) {
        $connMT.find('.cmt2').remove();
        doneOnce = false;

        //$('.connMT').filter('.cmtstats').attr('title', counterTitle);
        //$('.cmtstats').attr('title', counterTitle);
        //$connMT.filter('.cmtstats').add($connMT.find('.cmtstats')).attr('title', counterTitle);

        ++animateId;
        const thisId = animateId;
        const speed = document.hidden ? 0 : 1000;

        let $new = $('<b>').addClass('cmt cmt2').append(html);
        $connMT.append($new);

        let animOff = [],
            animOn = [];

        let $spans1 = $connMT.find('.cmt1').find('span');
        let $spans2 = $connMT.find('.cmt2').find('span');
        let spansMax = Math.max($spans1.length, $spans2.length);
        for (let i = 0; i < spansMax; ++i) {
            let $span1 = $spans1.eq(i);
            let $span2 = $spans2.eq(i);
            if ($spans1.length > i) {
                if ($spans2.length > i) {
                    if ($span1.text() != $span2.text()) {
                        animOff.push($span1.get(0));
                        animOn.push($span2.get(0));
                    }
                } else {
                    animOff.push($span1.get(0));
                }
            } else {
                animOn.push($span2.get(0));
            }
        }


        let doneAnimate = function () {
            if (doneOnce || thisId != animateId) {
                return;
            }
            doneOnce = true;
            $connMT.find('.cmt1').remove();
            $connMT.find('.cmt2').addClass('cmt1').removeClass('cmt2');
        };

        let animOnAnimate = function () {
            if (thisId != animateId) {
                return;
            }
            if (animOn.length) {
                if ($connMT.find('.cmt1').width() < $connMT.find('.cmt2').width()) {
                    $connMT.find('.cmt1').animate({
                        width: $connMT.find('.cmt2').width()
                    }, animOff.length == $spans1.length ? 0 : speed, 'swing', function () {

                    });
                }

                $(animOn).stop(true, false).animate({
                    opacity: 1
                }, speed, 'swing', function () {
                    doneAnimate();
                });
            } else {
                doneAnimate();
            }
        };

        let animOffAnimate = function () {
            if (thisId != animateId) {
                return;
            }
            if (animOff.length) {
                if (animOff.length != $spans1.length && $connMT.find('.cmt1').width() > $connMT.find('.cmt2').width()) {
                    $connMT.find('.cmt1').animate({
                        width: $connMT.find('.cmt2').width()
                    }, speed, 'swing', function () {

                    });
                }

                $(animOff).stop(true, false).animate({
                    opacity: 0
                }, speed, 'swing', function () {
                    if (animOff.length == $spans1.length && $connMT.find('.cmt1').width() > $connMT.find('.cmt2').width()) {
                        $connMT.find('.cmt1').css({
                            width: $connMT.find('.cmt2').width()
                        });
                    }

                    animOnAnimate();
                });
            } else {
                animOnAnimate();
            }
        };

        animOffAnimate();
    };
}